import { MutationTree } from 'vuex';
import { State } from './state';

import { AuthUser, AzureConfigEinstellung, ArchivUser, Benutzer } from '@/models/AuthModels';
import { Configuration } from '@azure/msal-browser';

export enum MutationTypes {
  LoginSuccess = 'LOGINSUCCESS',
  RefreshLoginSuccess = 'REFRESHLOGINSUCCESS',
  Logout = 'LOGOUT',

  SetAzureUsername = 'SETAZUREUSERNAME',
  SetIdentityToken = 'SETAZUREIDENTITYTOKEN',
  GetAzureLoginConfigSuccess = 'GETAZURELOGINCONFIGSUCCESS',
  SetAzureLoginAvailable = 'SETAZURELOGINAVAILABLE',
  SetAzureLogin = 'SETAZURELOGIN',

  SetArchivUsers = 'SETARCHIVUSERS',
  SetBenutzer = 'SETBENUTZER',
  AddOrUpdateBenutzer = 'ADDORUPDATEBENUTZER',
  RemoveBenutzer = 'REMOVEBENUTZER',
}

export type Mutations = {
  [MutationTypes.LoginSuccess](state: State, authUser: AuthUser): void;
  [MutationTypes.RefreshLoginSuccess](state: State, authUser: AuthUser): void;
  [MutationTypes.Logout](state: State): void;

  [MutationTypes.SetAzureUsername](state: State, username: string): void;
  [MutationTypes.SetIdentityToken](state: State, token: string): void;
  [MutationTypes.GetAzureLoginConfigSuccess](state: State, config: AzureConfigEinstellung): void;
  [MutationTypes.SetAzureLoginAvailable](state: State): void;
  [MutationTypes.SetAzureLogin](state: State, value: boolean): void;

  [MutationTypes.SetArchivUsers](state: State, archivUsers: Array<ArchivUser>): void;
  [MutationTypes.SetBenutzer](state: State, benutzer: Array<Benutzer>): void;
  [MutationTypes.AddOrUpdateBenutzer](state: State, benutzer: Benutzer): void;
  [MutationTypes.RemoveBenutzer](state: State, benutzerId: number): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.LoginSuccess](state: State, authUser: AuthUser) {
    state.authUser = authUser;
    localStorage.setItem('authUser', JSON.stringify(state.authUser));
  },

  [MutationTypes.RefreshLoginSuccess](state: State, authUser: AuthUser) {
    state.authUser = authUser;
    localStorage.setItem('authUser', JSON.stringify(state.authUser));
  },

  [MutationTypes.Logout](state: State) {
    state.authUser = null;
    localStorage.removeItem('authUser');
  },

  [MutationTypes.SetAzureUsername](state: State, username: string) {
    state.azureUsername = username;
  },

  [MutationTypes.SetIdentityToken](state: State, token: string) {
    state.identityToken = token;
  },

  [MutationTypes.SetAzureLoginAvailable](state: State) {
    state.azureLoginAvailable = true;
  },

  [MutationTypes.SetAzureLogin](state: State, value: boolean) {
    state.azureLogin = value;
  },

  [MutationTypes.GetAzureLoginConfigSuccess](state: State, config: AzureConfigEinstellung) {
    state.azureLoginAvailable = true;
    const msalconfig: Configuration = {
      auth: {
        clientId: config.clientId,
        authority: config.authority,
        redirectUri: config.redirectUri,
      },
      cache: {
        cacheLocation: 'localStorage',
      },
    };

    sessionStorage.setItem('msalconfig', JSON.stringify(msalconfig));
    state.msalConfig = msalconfig;
  },

  [MutationTypes.SetArchivUsers](state: State, archivUsers: Array<ArchivUser>) {
    state.archivUsers = archivUsers;
    sessionStorage.setItem('archivUsers', JSON.stringify(state.archivUsers));
  },

  [MutationTypes.SetBenutzer](state: State, benutzer: Array<Benutzer>) {
    state.benutzer = benutzer;
    sessionStorage.setItem('benutzer', JSON.stringify(state.benutzer));
  },

  [MutationTypes.AddOrUpdateBenutzer](state: State, benutzer: Benutzer) {
    const index = state.benutzer.findIndex((b) => b.id === benutzer.id);
    if (index !== -1) {
      state.benutzer.splice(index, 1, benutzer);
    } else {
      state.benutzer.push(benutzer); // Add new user
    }
    sessionStorage.setItem('benutzer', JSON.stringify(state.benutzer));
  },

  [MutationTypes.RemoveBenutzer](state: State, benutzerId: number) {
    state.benutzer = state.benutzer.filter((b) => b.id !== benutzerId);
    sessionStorage.setItem('benutzer', JSON.stringify(state.benutzer));
  },
};
